export default {"src":"/_next/static/media/documents_icon.a4e1f4e1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};